export default __webpack_public_path__ + "static/media/youtube.36c61308.svg";